import {whitelabelling as Whitelabelling} from 'whitelabelling';
import * as _ from 'underscore';

export function userInputAffinityGroups() {
    return {
        restrict: 'E',
        scope: {
            data: '=',
            categories: '=',
            hasRequired: '=',
            displayType: '@?',
        },
        templateUrl: Evisors.config.cdnRootWhitelabel +
            'ng-template/partials/registration/directives/userInputs/userInputAffinityGroups.tpl.html',
        controller: [
            '$scope', '$rootScope', function($scope, $rootScope) {
                $scope.whitelabelling = Whitelabelling;
                $scope.filteredGroups = [];
                $scope.pickedGroups = {
                    value: [],
                };

                $scope.customizedLabel = $scope.whitelabelling.settings['customized:affinity_groups:label'];

                $scope.selectedCategory = null;

                var oldBack = $rootScope.goToPreviousStep;

                $scope.enterCategory = function(cat) {
                    $scope.selectedCategory = cat;

                    // we start off with a change so that we can preload our selected groups if we have any
                    if ($scope.data) {
                        $scope.data.trigger('change');
                    }

                    // override the back button
                    $rootScope.goToPreviousStep = $scope.exitCategory;
                };

                $scope.exitCategory = function() {
                    $scope.selectedCategory = null;
                    $scope.pickedGroups.value = [];

                    // put the back button back to normal
                    $rootScope.goToPreviousStep = oldBack;
                };

                if ($scope.data) {
                    // listen for removals to our groups array and show
                    $scope.data.on('remove change', function() {
                        if (!$scope.selectedCategory) {
                            return;
                        }
                        $scope.pickedGroups.value = $scope.data.where(
                            {'affinityGroupCategoryid': $scope.selectedCategory.get('id')});
                    });
                }

                // watch for additions via the select
                $scope.$watch('pickedGroups.value', function(newVal, oldVal) {
                    if ($scope.data) {
                        // make sure we've added a new group, all other times we ignore it
                        if (newVal && oldVal && newVal.length > oldVal.length) {
                            $scope.data.add(newVal);
                            $scope.groupsErrors = false;
                        }
                    }
                });

                $scope.removeGroup = function(g) {
                    if ($scope.data) {
                        $scope.data.remove(g);
                    }

                    $scope.pickedGroups.value = _.without($scope.pickedGroups.value, g);
                };

                // if there's only one category they're picking from, start them off in that step
                if ($scope.categories && $scope.categories.length === 1) {
                    $scope.enterCategory($scope.categories.at(0));

                    // enter category normally overrides the back button to return the all categories page
                    // but if there's only one category, we don't want this behavior
                    // so we set the back button to work normally
                    $rootScope.goToPreviousStep = oldBack;
                }
            },
        ],
    };
}
